/**
 * 全局插件配置（学校端）
 * 统一注册第三方库、UI框架、扩展组件、全局工具和过滤器
 */
import Vue from 'vue';
import './axios';
import setting from './setting';
import util from '@/utils/util';
import alioss from '@/utils/alioss';
import permission from '@/utils/permission'; // 角色权限控制
// 第三方组件
import NProgress from 'nprogress'; // 顶部进度条
import 'nprogress/nprogress.css';
import VueClipboard from 'vue-clipboard2'; // 剪切板
// 扩展组件
import EleDataTable from '@/components/EleDataTable'; // 数据表格
import EleIconPicker from '@/components/EleIconPicker'; // 图标选择器
import EleAvatarList from '@/components/EleAvatarList'; // 头像列表
import EleDot from '@/components/EleDot'; // 状态文字
import EleResult from '@/components/EleResult'; // 操作结果
import EleTagsInput from '@/components/EleTagsInput'; // 标签输入框
import EleEmpty from '@/components/EleEmpty'; // 空视图
// UI框架
import ElementUI from 'element-ui'; // ElementUI
import 'element-ui/lib/theme-chalk/display.css';
import '@/styles/eleadmin/icon.scss'; // EleAdmin图标
import '@/styles/eleadmin/index.scss'; // EleAdmin样式
// 数据可视化组件库
import dataV from '@jiaminghi/data-view';

// 注册 DataV 数据可视化组件
Vue.use(dataV);
// 挂载全局工具和配置到 Vue 原型
Vue.prototype.$util = util;
Vue.prototype.$alioss = alioss;
Vue.prototype.$setting = setting;
// 注册全局插件
Vue.use(ElementUI, { size: 'medium' });
Vue.use(permission);
Vue.use(VueClipboard);
// 配置进度条（隐藏右侧旋转图标）
NProgress.configure({ showSpinner: false });

/* 全局注册常用组件，可在任意页面直接使用无需 import */
Vue.component(EleDataTable.name, EleDataTable);
Vue.component(EleIconPicker.name, EleIconPicker);
Vue.component(EleAvatarList.name, EleAvatarList);
Vue.component(EleDot.name, EleDot);
Vue.component(EleResult.name, EleResult);
Vue.component(EleTagsInput.name, EleTagsInput);
Vue.component(EleEmpty.name, EleEmpty);

/** 全局过滤器 - 可在模板中通过管道符使用（如 {{ time | timeAgo }}） */
/** 语义化时间过滤器 */
Vue.filter('timeAgo', (value, onlyDate) => {
  return util.timeAgo(value, onlyDate);
});
/** 数字补零过滤器 */
Vue.filter('digit', (value, length) => {
  return util.digit(value, length);
});
/** 日期格式化过滤器 */
Vue.filter('toDateString', (value, format) => {
  return util.toDateString(value, format);
});
/** HTML转义过滤器（防XSS） */
Vue.filter('escape', (value) => {
  return util.escape(value);
});
/** HTML转纯文本过滤器 */
Vue.filter('htmlToText', (value) => {
  return util.htmlToText(value);
});
/** 手机号脱敏过滤器 */
Vue.filter('phoneSafe', (phone) => {
  return util.phoneSafe(phone);
});
